




































































































import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";
import {
  allMathStrings,
  Calculator,
  fullySubbed,
  Inputs,
  iterativelySubbed,
} from "@/utils/calculator";
import { getOutputPower, Machine } from "@/utils/machine";
import { Cutter, getYoungsModulus } from "@/utils/cutter";
import { Material } from "@/utils/material";
import nerdamer from "nerdamer";
import { units } from "@/utils/units";

@Component
export default class CalculatorForm extends Vue {
  @Prop({ required: true }) calculator!: Calculator;
  @Prop({ required: true }) potentialCutters!: Cutter[];
  @Prop({ required: true }) potentialMaterials!: Material[];
  @Prop({ required: true }) updateCalculator!: (calculator: Calculator) => void;
  @Prop({ required: true }) deleteCalculator!: () => void;

  valid = true;
  name = "New Calculator";
  machine: Machine = null;
  cutter: Cutter = null;
  material: Material = null;

  showEquations = true;

  get inputs(): Inputs {
    return {
      chipload: this.numberFields.chipload.value,
      woc: this.numberFields.woc.value,
      doc: this.numberFields.doc.value,
      rpm: this.numberFields.rpm.value,
      maxAcceptableDeflection: this.numberFields.maxAcceptableDeflection.value,
      cutterDiameter: this.cutter.diameter,
      materialKFactor: this.material.kFactor,
      cutterFlutes: this.cutter.flutes,
      maximumMachineForce: this.machine.maximumMachineForce,
      routerOutputPower: getOutputPower(this.machine.router),
      cutterOverallStickout: this.cutter.overallStickout,
      cutterYoungsModulus: getYoungsModulus(this.cutter.material),
      cutterShankDiameter: this.cutter.shankDiameter,
      cutterLength: this.cutter.length,
    };
  }

  get allMath() {
    return allMathStrings(
      this.inputs.woc,
      this.inputs.cutterDiameter,
      this.inputs.cutterShankDiameter
    );
  }
  get allValues() {
    try {
      return iterativelySubbed(this.inputs);
    } catch {
      return {
        adjustedChipload: 0,
        feedrate: 0,
        materialRemovalRate: 0,
        powerUsage: 0,
        torque: 0,
        machineForce: 0,
        machineForcePercent: 0,
        availablePowerPercent: 0,
        routerCutterPowerIncrease: 0,
        maxDeflection: 0,
        maxDeflectionPercent: 0,
      };
    }
  }

  valueDisplay(column: string, value: number): string {
    if (units[column]) {
      return `${units[column].formatting(value)} ${units[column].unit}`;
    } else {
      return value;
    }
  }

  asTex(key: string) {
    return nerdamer(this.allMath[key]).toTeX();
  }

  subbed(key: string) {
    //@ts-ignore
    return nerdamer(fullySubbed(key, this.allMath)).toTeX();
  }

  numberFields = {
    chipload: { name: "Chipload (in)", value: 0 },
    woc: { name: "Width of Cut (in)", value: 0 },
    doc: { name: "Depth of Cut (in)", value: 0 },
    rpm: { name: "RPM", value: 0 },
    maxAcceptableDeflection: {
      name: "Maximum Acceptable Deflection (in)",
      value: 0,
    },
  };

  created() {
    //@ts-ignore
    this.name = this.calculator.name;
    this.machine = this.calculator.machine;
    this.cutter = this.calculator.cutter;
    this.material = this.calculator.material;
    for (const numberField of Object.keys(this.numberFields)) {
      this.numberFields[numberField].value = this.calculator[numberField];
    }
  }

  requiredRule(name: string) {
    return (v) => !!v || `${name} is required`;
  }

  validate() {
    //@ts-ignore
    this.$refs.form.validate();
    this.updateCalculator({
      name: this.name,
      machine: this.machine,
      cutter: this.cutter,
      material: this.material,
      chipload: this.numberFields.chipload.value,
      woc: this.numberFields.woc.value,
      doc: this.numberFields.doc.value,
      rpm: this.numberFields.rpm.value,
      maxAcceptableDeflection: this.numberFields.maxAcceptableDeflection.value,
    });
  }

  reset() {
    //@ts-ignore
    this.$refs.form.reset();
  }
  resetValidation() {
    //@ts-ignore
    this.$refs.form.resetValidation();
  }
}
